import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/**
 * The payout report poller emails this team's recipients. Off holds the team
 * (not polled, not retried), so its owed reports wait rather than being skipped.
 */
export const hsaPayoutReportEmailsFlag = featureFlag(
  "hsa-payout-report-emails",
  teamContext,
).boolean(false);
